module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box",
    on: {
      "click": _vm.toggleBubble
    }
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("\n    i\n  ")]), _vm._v(" "), (_vm.isOpen === true && true === false) ? _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-side"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df012996"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Infobox.vue
// module id = 121
// module chunks = 0